import { categories } from '@/mocks/comics';

const helpLinks = ['使用帮助', '意见反馈', '隐私政策', '服务条款', '联系我们'];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-foreground-800 text-foreground-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-book-2-fill"></i>
              </span>
              <span className="font-heading text-xl text-background-50">4399漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300">
              专注漫画分类浏览与快速查找的平台，提供热门排行、新上架作品与完结作品库，助你从海量漫画中精准找到想看的作品。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#top" aria-label="微博" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#top" aria-label="公众号" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#top" aria-label="哔哩哔哩" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center text-foreground-200 hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">热门分类</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
              {categories.slice(0, 8).map((c) => (
                <li key={c.name}>
                  <a href="#categories" className="text-foreground-300 hover:text-primary-300 transition-colors">
                    {c.name}漫画
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快捷入口</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><a href="#ranking" className="text-foreground-300 hover:text-primary-300 transition-colors">热门排行</a></li>
              <li><a href="#new" className="text-foreground-300 hover:text-primary-300 transition-colors">新上架作品</a></li>
              <li><a href="#completed" className="text-foreground-300 hover:text-primary-300 transition-colors">完结作品库</a></li>
              <li><a href="#faq" className="text-foreground-300 hover:text-primary-300 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">帮助支持</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              {helpLinks.map((link) => (
                <li key={link}>
                  <a href="#top" className="text-foreground-300 hover:text-primary-300 transition-colors">{link}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-600 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-400">
          <p>© {year} 4399漫画网 · 仅供学习演示，请支持正版漫画</p>
          <p>示例邮箱：contact@4399comic.example.com</p>
        </div>
      </div>
    </footer>
  );
}